import { render, staticRenderFns } from "./OfficeNewPage.vue?vue&type=template&id=a2c298b8&"
import script from "./OfficeNewPage.vue?vue&type=script&lang=ts&"
export * from "./OfficeNewPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports